import React from "react";
import { IRoute } from "./interfaces/route.interface";

const LoginPage = React.lazy(() =>  import("../pages/LoginPage"));

export const authRoutes:IRoute[] = [
    {
        path: "/login",
        exact: true,
        component: LoginPage,
    }
];